import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SignaturePad from '../../components/Signature/SignaturePad';
import publicApi from '../../services/publicApi';
import { InvoiceSignatureViewModel } from '../../models/Invoice/InvoiceViewModel';
import { toIdentifierMask } from '../../services/mask';
import { useQuery } from '../../services/utils';

export default function SignIndex() {
  const { id } = useParams();
  const query = useQuery();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [invoice, setInvoice] = useState<InvoiceSignatureViewModel>(
    null as unknown as InvoiceSignatureViewModel
  );

  async function getInvoice() {
    if (id) {
      const response = await publicApi.get(`/invoices/${id}`);
      setInvoice(new InvoiceSignatureViewModel(response.data));
      setIsLoading(false);
    }
  }

  const handleSignature = async (dataUrl: string | undefined) => {
    try {
      await publicApi.post(`/invoices/${id}/sign`, { signature: dataUrl });
      toast.success('A Ordem de serviço foi assinada');
      const redirectUrl = query.get('redirectUrl');
      if (redirectUrl) navigate(redirectUrl);
      else window.location.reload();
    } catch (e: any) {
      console.log(e);
    }
  };

  useEffect(() => {
    getInvoice();
  }, [id]);

  if (isLoading) {
    return (
      <div
        className='d-flex align-items-center justify-content-center'
        style={{ height: '100vh' }}
      >
        <div
          className='spinner-border'
          style={{ width: '3rem', height: '3rem' }}
          role='status'
        >
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

  return invoice.isSigned ? (
    <>
      <div className='alert alert-success' role='alert'>
        <h4 className='alert-heading'>OS assinada</h4>
        <hr />
        <p className='mb-0'>
          A ordem de serviço foi devidamente autorizada e confirmada através de
          assinaturas, indicando o consentimento e a validação.
        </p>
      </div>
      <div className='d-flex justify-content-center'>
        <div className='card' style={{ width: '90%' }}>
          <div className='card-header bg-white'>
            <img width={300} src={invoice.signature} alt='Assinatura' />
          </div>
          <div className='card-body'>
            <h5 className='card-title'>
              {invoice.customerName},&nbsp;
              {toIdentifierMask(
                invoice.customerIdentifier,
                invoice.customerType
              )}
            </h5>
            <p className='card-text'>{invoice.signedAt?.toLocaleString()}</p>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className='container-fluid mt-3'>
      <SignaturePad handleSignature={handleSignature} />
    </div>
  );
}
